import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=29ac0cf0"
import script from "./DocumentsView.vue?vue&type=script&lang=js"
export * from "./DocumentsView.vue?vue&type=script&lang=js"
import style0 from "./DocumentsView.vue?vue&type=style&index=0&id=29ac0cf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports